import React, { useState } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { style } from "../style";


export default function Navigation()
{

    return (
        <header className="sticky top-0 z-50 w-full bg-black shadow-md">
            <nav className="flex flex-row w-full md:w-[65rem] md:mx-auto">
                <Link className="flex-1 text-center text-white font-navine font-bold uppercase text-base tracking-wider px-4 py-4 border-b-2 border-transparent hover:border-red-600 hover:bg-neutral-800 transition-colors" to="/">
                    Home
                </Link>
                <Link className="flex-1 text-center text-white font-navine font-bold uppercase text-base  tracking-wider px-4 py-4 border-b-2 border-transparent hover:border-red-600 hover:bg-neutral-800 transition-colors" to="/goals">
                    About
                </Link>
                <Link className="flex-1 text-center text-white font-navine font-bold uppercase text-base tracking-wider px-4 py-4 border-b-2 border-transparent hover:border-red-600 hover:bg-neutral-800 transition-colors" to="/characters">
                    Tekbros
                </Link>
            </nav>
        </header>
    );
}